import DataTable from 'react-data-table-component';
import LoaderComponent from '@components/atom/layout/loader';
import FadeLoader from 'react-spinners/FadeLoader';

const GridClickColorAtom = ({ columns, data, rowClickHandler, categoriesSelected, height }) => {
  const rowCondition = [
    {
      when: (row) => categoriesSelected.includes(row.property),
      style: {
        'backgroundColor': 'green',
        'color': 'white',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  ];
  return (
    <DataTable
      columns={columns}
      data={data}
      onRowClicked={rowClickHandler}
      conditionalRowStyles={rowCondition}
      progressPending={!data && !columns}
      progressComponent={
        <LoaderComponent height={height}>
          <FadeLoader />
        </LoaderComponent>
      }
    />
  );
};

export default GridClickColorAtom;
